import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

const listingData = types.model('listingData', {
  clusterName: types.maybeNull(types.string),
  serverDateTime: types.maybeNull(types.string),
  createdDate: types.maybeNull(types.number),
  clusterId: types.maybeNull(types.string),
  bookId: types.maybeNull(types.string),
  channelsId: types.maybeNull(types.string),
  userCommand: types.maybeNull(types.string),
  userId: types.maybeNull(types.string),
  dateStamp: types.maybeNull(types.string),
  requestId: types.maybeNull(types.string),
  type: types.maybeNull(types.string)
});

const TrendsClusterList = types
  .model('TrendsClusterList', {
    data: types.optional(types.array(listingData), [])
  })
  .actions((self) => ({
    fetch(payload, tenantId) {
      Framework.getEventManager().publish(constants.GET_TRENDS_CLUSTER_LIST, {
        payload,
        tenantId
      });
    },
    setResponse(response) {
      const enrichedResponse = {
        ...response,
        data: (response.data || []).map((item) => ({
          ...item,
          createdDate: utils.toEpochUTC(item.serverDateTime)
        }))
      };
      applySnapshot(self, enrichedResponse);
      Framework.getEventManager().publish(constants.GET_TRENDS_CLUSTER_LISTING_DATA);
    },
    resetStoreValues() {
      const initialState = [];
      applySnapshot(self.data, initialState);
    }
  }));

export default TrendsClusterList;
